import { render } from "./AppSkeletonTakePhoto.vue?vue&type=template&id=828370e0&scoped=true"
import script from "./AppSkeletonTakePhoto.vue?vue&type=script&lang=js"
export * from "./AppSkeletonTakePhoto.vue?vue&type=script&lang=js"

import "./AppSkeletonTakePhoto.vue?vue&type=style&index=0&id=828370e0&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828370e0"]])

export default __exports__